export const TO_NOT_TRANSFORM = Object.freeze([
  // non-standard snake keys
  'has_email2',
  'has_email3',
]);

// this list will FORCED converted from/to camelCase/snake_case
export const TO_ALWAYS_TRANSFORM = Object.freeze(['_metadata']);
